import classNames from 'classnames';
import React from 'react';

import { useFocusElementOnExit } from '@eika/hooks';
import { Icon, IconTypes } from '@eika/icon';

import type { RemovableChipProps } from './types';

const RemovableChip: React.FC<RemovableChipProps> = ({
    className,
    children,
    onRemove,
    onClick,
    elementToFocusOnExit,
    ...rest
}) => {
    useFocusElementOnExit(elementToFocusOnExit);
    return (
        <button
            {...rest}
            type="button"
            className={classNames('sgw-chip', className, 'sgw-chip__removable')}
            onClick={(e) => {
                onClick?.(e);
                onRemove?.();
            }}
        >
            {children}
            <span className="sgw-chip__icon-wrapper">
                <Icon className="sgw-chip__icon" type={IconTypes.KRYSS_24} />
            </span>
        </button>
    );
};

export default RemovableChip;
